import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=f923887a&"
import script from "./SidebarLink.vue?vue&type=script&lang=js&"
export * from "./SidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/repos/irs/irs/frontend/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f923887a', component.options)
    } else {
      api.reload('f923887a', component.options)
    }
    module.hot.accept("./SidebarLink.vue?vue&type=template&id=f923887a&", function () {
      api.rerender('f923887a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/SidebarLink.vue"
export default component.exports